
import s0 from '~/.nuxt/gb-cms/sections/AboutUs'
import s1 from '~/.nuxt/gb-cms/sections/GalleryList'
import s2 from '~/.nuxt/gb-cms/sections/ImageTextList'
import s3 from '~/.nuxt/gb-cms/sections/ContactForm'
import s4 from '~/.nuxt/gb-cms/sections/HeroImage'
import s5 from '~/.nuxt/gb-cms/sections/HeroSlider'
import s6 from '~/.nuxt/gb-cms/sections/InfiniteSlider'
import s7 from '~/.nuxt/gb-cms/sections/ProductList'
import s8 from '~/.nuxt/gb-cms/sections/StatisticsSection'
import s9 from '~/.nuxt/gb-cms/sections/StepsSection'
import s10 from '~/.nuxt/gb-cms/sections/PrivacyPolicy'
import s11 from '~/.nuxt/gb-cms/sections/ImageDropdownText'

const sectionMapper = {
	'about-us': s0,
	'gallery-list': s1,
	'image-text-list': s2,
	'contact-form': s3,
	'hero-image': s4,
	'hero-slider': s5,
	'infinite-slider': s6,
	'product-list': s7,
	'statistics-section': s8,
	'steps-section': s9,
	'privacy-policy': s10,
	'image-dropdown-text': s11
}

export default sectionMapper
